import { UserContext } from '@context/UserContext'; // Adjust the import path as needed
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { cancelTossPmntOrder } from '../../pages/common/paymentService'; // Adjust the import path as needed

const PaymentDetailPopup = ({
  isOpen,
  setIsOpen,
  selectedItem,
}: {
  isOpen: any;
  setIsOpen: any;
  selectedItem: any; // selectedItem의 구조에 따라 수정이 필요합니다.
}) => {
  const navigate = useNavigate();
  const { session_token } = useContext(UserContext);

  const handleClosePopup = () => {
    setIsOpen(false);
  };

  const handleCancelPayment = async () => {
    console.log('handleCancelPayment 호출');
    console.log('selectedItem:', selectedItem);

    try {
      if (!session_token) {
        throw new Error('세션 토큰이 없습니다. 다시 로그인해 주세요.');
      }
      console.log('세션 토큰:', session_token);

      // 결제 취소 API 호출
      await cancelTossPmntOrder({
        orderId: selectedItem.orderId,
        paymentKey: selectedItem.payments.paymentKey,
        cancel_reason: '고객요청', // 취소 이유를 동적으로 처리하는 것이 좋습니다.
        token: session_token,
      });
      // 취소가 성공하면 메시지를 띄우거나 다른 처리를 수행할 수 있습니다.
      alert("결제가 취소되었습니다.");
      handleClosePopup(); // 취소 성공 시 팝업을 닫습니다.
    } catch (error) {
      console.error("결제 취소 에러:", error);
      // 실패 시 에러 처리를 추가할 수 있습니다.
      alert("결제 취소 중 오류가 발생했습니다.");
    }
  };

console.log('selectedItem:', selectedItem); // selectedItem 객체 확인

// selectedItem의 구조와 paymentKey 접근 방식 확인
console.log('selectedItem.paymentKey:', selectedItem.paymentKey);

// 또는 복잡한 구조라면 다음과 같이 접근할 수 있습니다.
console.log('selectedItem.payments.paymentKey:', selectedItem.payments?.paymentKey);

  const getChargeMethod = (type: string) => {
    switch (type) {
      case 'inapp':
        return '앱에서 충전';
      case 'web':
        return '웹';
      default:
        return '웹에서 충전';
    }
  };

  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('ko-KR', { style: 'currency', currency: 'KRW' }).format(amount);
  };

  return (
    <div className="fixed top-0 right-0 flex justify-center items-center w-full h-screen z-30">
      <div className="fixed top-0 right-0 bottom-0 left-0 bg-black opacity-50 z-30"></div>
      <div className="border border-black border-4 border-solid relative font-notokr bg-white rounded-md shadow-lg z-40 w-96 bg-gray-100">
        <div className="h-12 bg-alco-mint flex px-[1.5rem]">
          <div className="font-notokr text-white font-bold my-auto">
            충전 상세 내역
          </div>
          <button
            onClick={handleClosePopup}
            className="absolute top-0 right-0 p-2"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-8 w-8 text-gray-400 hover:text-gray-500"
              fill="none"
              viewBox="0 0 24 24"
              stroke="white"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
        <div className="px-[1.5rem] py-3">
          <div className=" gap-4 flex flex-col">
            <div>충전방법: {getChargeMethod(selectedItem.type)}</div>
            <div>충전일시: {selectedItem.type === 'inapp' ? selectedItem.purchaseTime : selectedItem.createdAt}</div>
            <div>결재금액: {selectedItem.type === 'inapp' ? selectedItem.formattedPrice : formatCurrency(selectedItem.amount)}</div>
            <div>충전코인: {selectedItem.default_coin} ContentCoin</div>
            <div>보너스코인: {selectedItem.bonus_coin} ContentCoin</div>
          </div>
          <div className="leading-[1.2rem] py-5">
            <div className="text-left font-normal text-[#757575] text-[10px]">
              <p>• 이미 사용한 코인은 결제취소할 수 없습니다.</p>
              {selectedItem.type === 'inapp' ? (
                <p>• 인앱결재한 코인은 앱에서만 취소가능합니다.</p>
              ) : (
                <p>• 결제취소에 대한 자세한 문의는 [고객 지원] 페이지에서 문의해주시기 바랍니다.</p>
              )}
            </div>
            {selectedItem.type === 'inapp' ? (
              <button
                className="flex disabled cursor-default w-full h-7 mt-5 bg-gray-400 font-thin text-white font-notokr rounded-[8px]  justify-center items-center ml-auto"
              >
                {"앱에서만 취소가능합니다."}
              </button>
            ) : (
              <button
                className="flex w-full h-7 mt-5 bg-alco-mint font-thin text-white font-notokr rounded-[8px]  justify-center items-center ml-auto"
                onClick={handleCancelPayment} // 결제 취소 버튼 클릭 시 handleCancelPayment 함수 실행
              >
                {"결제취소하기"}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentDetailPopup;
